import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Chart, registerables } from 'chart.js';
import configApi from '../../config';

Chart.register(...registerables);

const RevenueByYearChart = () => {
    const chartRef = useRef(null);
    const [chartInstance, setChartInstance] = useState(null);
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const fetchRevenueData = async () => {
        try {
            const response = await axios.get(
                `${configApi.apiEndpoint}/api/Stats/RevenueByYear`,
                config
            );
            const safeData = Array.isArray(response.data) ? response.data : [];
            createChart(safeData);
        } catch (error) {
            console.error('Chyba pri načítavaní ročného zisku:', error);
        }
    };

    const createChart = (data) => {
        const labels = data.map(item => item.year ? item.year.toString() : '');
        const revenues = data.map(item => item.revenue);

        const ctx = chartRef.current.getContext('2d');
        const gradient = ctx.createLinearGradient(0, 0, 0, 300);
        gradient.addColorStop(0, 'rgba(39, 174, 96, 0.5)'); // Dark emerald
        gradient.addColorStop(1, 'rgba(39, 174, 96, 0.0)');

        const chartConfig = {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    label: 'Celkový ročný zisk (€)',
                    data: revenues,
                    fill: true,
                    backgroundColor: gradient,
                    borderColor: '#27ae60',
                    borderWidth: 3,
                    tension: 0.4,
                    pointRadius: 4,
                    pointHoverRadius: 7,
                    pointBackgroundColor: '#27ae60',
                    pointBorderColor: '#fff',
                    pointBorderWidth: 2
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        beginAtZero: true,
                        title: {
                            display: true,
                            text: 'Priemerný Zisk (€)'
                        },
                        ticks: {
                            callback: function (value) {
                                return new Intl.NumberFormat('sk-SK').format(value) + ' €';
                            }
                        }
                    },
                    x: {
                        title: {
                            display: false
                        }
                    }
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    title: {
                        display: false
                    },
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                let label = context.dataset.label || '';
                                if (label) {
                                    label += ': ';
                                }
                                if (context.parsed.y !== null) {
                                    label += new Intl.NumberFormat('sk-SK').format(context.parsed.y) + ' €';
                                }
                                return label;
                            }
                        }
                    }
                }
            }
        };

        if (chartRef.current) {
            const existingChart = Chart.getChart(chartRef.current);
            if (existingChart) {
                existingChart.destroy();
            }
        }

        const newChartInstance = new Chart(ctx, chartConfig);
        setChartInstance(newChartInstance);
    };

    useEffect(() => {
        fetchRevenueData();
    }, []);

    return (
        <div className="card-custom h-100">
            <div className="card-custom-header">
                <h5 className="m-0">Medziročný rast (YoY)</h5>
            </div>
            <div style={{ height: '300px' }}>
                <canvas ref={chartRef}></canvas>
            </div>
        </div>
    );
};

export default RevenueByYearChart;
